import {ContractAddressMap, DexQuoter, VaultInterface} from './interfaces';

export const Vaults: VaultInterface[] = [
  {
    address: "0xc52391ab0f4f35dcada55a4ea3e2a8d943456294",
    decimals: 8,
    underlying: "0xa2fbf111458f5e052c07631efee105a13c9e6370",
    uSymbol: "USDT",
    uName: "USDT",
    uDecimals: 6,
    lendEnabled: true,
    borrowEnabled: true,
    leverage: 10,
    buyEnabled: false,
    isStable: true,
    buyAssets: ["0xd14bc4a6404ee09ef78213c830a36cc939b6fee6"]
  },
 
  {
    address: "0xd14bc4a6404ee09ef78213c830a36cc939b6fee6",
    decimals: 8,
    underlying: "0x1840dc1f9bbde4a27d05f05727737e502a7af1fb",
    uSymbol: "CGO",
    uName: "CGO",
    uDecimals: 18,
    lendEnabled: false,
    borrowEnabled: false,
    buyEnabled: true,
    borrowAssets: ["0xc52391ab0f4f35dcada55a4ea3e2a8d943456294"],
    tradingWidgetConfig: {
      source: 'BITRUE',
      pair: 'CGOUSDT'
    }
  }
];

export const defaultTradePair  = "usdt-cgo";


export const ContractAddresses: ContractAddressMap = {
  'DataUtility': "0x414862F18551F5458007f28F37473119C35B53dA",
  'Comptroller': "0x3F3a870e0bB73622a66C287Ed6375c699125cb43"
}

export const blockExplorer = 'https://explorer.apothem.network';

export const blocksPerDay = 43200; // 2sec per block as per apothem explorer
export const oraclePriceDecimals='16';

export const DexQuoters : DexQuoter[] = [
  {
    id: '6',
    name: 'xswap',
    slug: 'xswap',
    type: 'Contract',
    address: "0xF27602eC5576CC39EfCBfFC2f4c2fEB2D070aC8C",
    functionName: 'getAmountsOut'
  }
]

export const eventsApiChainSlug='xdc-testnet';
export const faucetURL = "https://faucet.apothem.network/";
export const faucetAddress = "0x7f8d5D2e3B4a9905a4078dfb45cC5964B877A52F";